import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, PACKAGES_CREATE, PACKAGES_EDIT, TEMPLATES_EDIT} from "../../../routes/frontend.routes";
import {createColumnHelper} from "@tanstack/react-table";
import {IndeterminateCheckbox} from "../../../../app-common/components/input/checkbox.intermediate";
import React from "react";
import {TableComponent} from "../../../../app-common/components/table/table";
import {PACKAGE_LIST} from "../../../../api/routing/routes/admin.backend.app";
import {Link} from "react-router-dom";
import moment from "moment";
import {Package} from "../../../../api/model/package";

export const Packages = () => {
  const {t} = useTranslation();
  const columnHelper = createColumnHelper<Package>();

  const columns = [
    columnHelper.accessor('uuid', {
      enableSorting: false,
      header: ({table}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: table.getIsAllRowsSelected(),
              indeterminate: table.getIsSomeRowsSelected(),
              onChange: table.getToggleAllRowsSelectedHandler(),
            }}
          />
        </div>
      ),
      cell: ({row}) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    }),
    columnHelper.accessor('name', {
      header: () => t('Name'),
    }),
    columnHelper.accessor('price', {
      header: () => t('Package Price'),
    }),
    columnHelper.accessor('messages', {
      header: () => t('Messages'),
    }),
    columnHelper.accessor('pointsPerMessage', {
      header: () => t('Points per message'),
    }),
    columnHelper.accessor('isActive', {
      header: () => t('Active?'),
      cell: info => info.getValue() ? t('Yes') : t('No')
    }),
    columnHelper.accessor('updatedAt.datetime', {
      header: () => t('Updated at'),
      cell: info => moment(info.getValue()).format('lll'),
    }),
    columnHelper.accessor('uuid', {
      header: () => t('Actions'),
      cell: info => (
        <Link to={PACKAGES_EDIT.replace(':id', info.getValue())} className="btn btn-primary">
          {t('Update')}
        </Link>
      ),
    })
  ];

  return (
    <DashboardLayout
      title="Packages"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Packages'), current: true}
      ]}
      buttons={[
        <Link to={PACKAGES_CREATE} className="float-end btn btn-primary">{t('Create')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('List')}
              </h5>
              <TableComponent columns={columns} url={PACKAGE_LIST}/>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
